<mat-sidenav-container class="example-container">
    <mat-sidenav #sidenav mode="side">
        <app-sidenav></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
